<template lang="html">
  <v-container>
    <BugDetailsDialog :details_dialog="getDetailsDialog" @bugDetailsDialogClose="resetDetailsDialog()" />
    <v-row>
      <v-col xs12 md3>
          <v-card max-width="600" color="secondary lighten-1" class="pa-2">
            <h2>Open</h2>
            <h3>Sort By</h3>
            <v-btn :class="getSortBy === 'identifier'?'grey darken-3':''" @click="setSortBy('identifier')">Name</v-btn>
            <v-btn :class="getSortBy === 'os'?'grey darken-3':''" @click="setSortBy('os')">os</v-btn>
            <v-btn :class="getSortBy === 'error'?'grey darken-3':''" @click="setSortBy('error')">Error Code</v-btn>
            <v-btn :class="getSortBy === 'created'?'grey darken-3':''" @click="setSortBy('created')">created</v-btn>
            <v-spacer/>
            <v-btn :class="getSortType === 'ascending'?'grey darken-3':''" @click="setSortType('ascending')">ascending</v-btn>
            <v-btn :class="getSortType === 'descending'?'grey darken-3':''" @click="setSortType('descending')">descending</v-btn>
            <ul class="drag-inner-list">
              <li class="drag-item">
                <draggable
                :disabled="!hasAllOfPermissions([
                  'BUG UPDATE', 'BUG DELETE'
                ])"
                :value="getOpenBugs"
                @input="changeHandlerOpen($event)"
                @add="updateBugStatus($event, 'open')"
                animation="300"
                v-bind="bug_draggable">
                    <BugCard v-for="(bug, index) in getOpenBugs" :key="bug.id" :bug="bug">
                      <template #actions>
                        <v-btn @click="requestActionsMutations(bug)" text>Details</v-btn>
                        <StandardDeleteBtn :btnclass="'pull-right'" :el="bug" @deleteClick="deleteBug({id: bug.id, index: index})" />
                      </template>
                    </BugCard>
                </draggable>
              </li>
            </ul>
          </v-card>
      </v-col>
      <v-col xs12 md3>
        <v-card max-width="600" color="secondary lighten-1" class="pa-2">
          <h2>Development</h2>
          <ul class="drag-inner-list">
            <li class="drag-item">
              <draggable
              :disabled="!hasAllOfPermissions([
                'BUG UPDATE', 'BUG DELETE'
              ])"
              :value="getDevelopmentBugs"
              @input="changeHandlerDevelopment($event)"
              @add="updateBugStatus($event, 'development')"
              animation="300"
              v-bind="bug_draggable">
                <BugCard v-for="bug in getDevelopmentBugs" :key="bug.id" :bug="bug">
                  <template #actions>
                    <v-btn @click="requestActionsMutations(bug)" text>Details</v-btn>
                    <!-- <StandardDeleteBtn :btnclass="'pull-right'" :el="bug" @deleteClick="deleteBug(bug)" /> -->
                  </template>
                </BugCard>
              </draggable>
            </li>
          </ul>
        </v-card>
      </v-col>
      <v-col xs12 md3>
        <v-card max-width="600" color="secondary lighten-1" class="pa-2">
          <h2>Closed</h2>
          <ul class="drag-inner-list">
            <li class="drag-item">
              <draggable
              :disabled="!hasAllOfPermissions([
                'BUG UPDATE', 'BUG DELETE'
              ])"
              :value="getClosedBugs"
              @input="changeHandlerClosed($event)"
              @add="updateBugStatus($event, 'closed')"
              animation="300"
              v-bind="bug_draggable">
                <BugCard v-for="bug in getClosedBugs" :key="bug.id" :bug="bug">
                  <template #actions>
                    <v-btn @click="requestActionsMutations(bug)" text>Details</v-btn>
                    <!-- <StandardDeleteBtn :btnclass="'pull-right'" :el="bug" @deleteClick="deleteBug({id: id, index: index})" /> -->
                  </template>
                </BugCard>
              </draggable>
            </li>
          </ul>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import draggable from "vuedraggable"
import store from '@/store/index';
import StandardDeleteBtn from '@/components/StandardComponents/StandardDeleteBtn.component.vue';
import BugCard from '@/components/BugReports/BugCard.component.vue';
import BugDetailsDialog from '@/components/BugReports/BugDetailsDialog.component.vue';
import {
  mapGetters, mapActions
} from 'vuex';
export default {
  name: 'BugReports',
  components: {
    BugCard,
    draggable,
    BugDetailsDialog,
    StandardDeleteBtn
   },
  beforeRouteEnter (to, from, next) {
    if (
      store.state.BugReport.open_bugs.length === 0 &&
      store.state.BugReport.dev_bugs.length === 0 &&
      store.state.BugReport.closed_bugs.length === 0
    ) {
      store.dispatch('BugReport/requestBugsForManagement', '?limit=10&offset=0').then(res => next(res));
    } else {
      next();
    }
  },
  data: function () {
    return {
      bug_draggable: {
        group: {
          name: 'bug_draggable',
          pull: true,
          put: true
        }
      }
    }
  },
  computed: {
    ...mapGetters('Auth', [
      'hasAllOfPermissions'
    ]),
    ...mapGetters('BugReport', [
      'getOpenBugs',
      'getDevelopmentBugs',
      'getClosedBugs',
      'getDetailsDialog',
      'isLoading',
      'getSortBy',
      'getSortType'
    ])
  },
  methods: {
    ...mapActions('BugReport', [
      'requestActionsMutations',
      'resetDetailsDialog',
      'setBugList',
      'changeBugStatus',
      'deleteBug',
      'setSortBy',
      'setSortType'
    ]),
    updateBugStatus(event, status){
      let ids = [];
      switch (status) {
        case 'open':
          ids = this.getOpenBugs[event.newIndex].ids;
          break;
        case 'development':
          ids = this.getDevelopmentBugs[event.newIndex].ids;
          break;
        case 'closed':
          ids = this.getClosedBugs[event.newIndex].ids;
          break;
      }
      for (let i = 0; i < ids.length; i++) {
        this.changeBugStatus({
          status,
          id: ids[i],
          index: event.newIndex
        });
      }
    },
    sortByOs(){
      this.getOpenBugs.sort(function(a, b) {
      var nameA = a.os.toUpperCase(); // Groß-/Kleinschreibung ignorieren
      var nameB = b.os.toUpperCase(); // Groß-/Kleinschreibung ignorieren
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // Namen müssen gleich sein
      return 0;
    });
    },
    changeHandlerOpen(bugs){
      this.setBugList({ status: 'open', bugs})
    },
    changeHandlerDevelopment(bugs){
      this.setBugList({ status: 'development', bugs})
    },
    changeHandlerClosed(bugs){
      this.setBugList({ status: 'closed', bugs})
    }
  }
}
</script>

<style lang="css" scoped>

.drag-outer-list{
  list-style-type:none
}

.drag-inner-list {
  height: 60vh;
  overflow: auto;
  list-style-type:none
}

</style>
